module.exports = __webpack_public_path__ + "img/icon-lock-green-quest-dark.90e0c1fb.svg";